import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './PostFooter.css';
import { FaCamera, FaSmile, FaCheck, FaSpinner } from 'react-icons/fa';

const PostFooter = ({ 
  editMode,
  isProcessing,
  isLoadingPreview,
  canSubmit,
  isScheduledPost,
  onFileChange,
  onToggleFeelingSelector,
  onSubmit
}) => {
  const fileInputRef = useRef(null);

  const handleFileClick = () => {
    if (editMode) return;
    fileInputRef.current?.click();
  };

  const getSubmitText = () => {
    if (editMode) return "Mettre à jour";
    if (isScheduledPost) return "Programmer";
    return "Publier";
  };

  return (
    <div className="pf-container">
      <div className="pf-tools">
        <div
          className="pf-tool-icon"
          onClick={handleFileClick}
          title="Ajouter une photo ou vidéo"
        >
          <FaCamera />
        </div>
        <input
          type="file"
          ref={fileInputRef}
          onChange={onFileChange}
          accept="image/*,video/*"
          disabled={editMode}
          style={{ display: 'none' }}
        />
        
        <div
          className="pf-tool-icon"
          onClick={onToggleFeelingSelector}
          title="Comment vous sentez-vous?"
        >
          <FaSmile />
        </div>
      </div>
      
      <div
        className={`pf-submit ${editMode ? 'pf-edit-mode' : ''}`}
        onClick={onSubmit}
        style={{
          opacity: isProcessing || isLoadingPreview || !canSubmit ? 0.7 : 1,
          cursor: isProcessing || isLoadingPreview || !canSubmit ? 'not-allowed' : 'pointer'
        }}
      >
        {isProcessing || isLoadingPreview ? (
          <FaSpinner className="pf-loading-icon" />
        ) : (
          <FaCheck />
        )}
        <span>{getSubmitText()}</span>
      </div>
    </div>
  );
};

export default PostFooter;
export { PostFooter };